import { databases } from "@/lib/appwrite"
import { Query } from "appwrite"
import type { ServiceReport } from "./types"

const DB = import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID
const COL = import.meta.env.VITE_BLOCKCHAIN_SERVICE_REPORT_COLLECTION_ID

export const getReportsByInstrument = async (instrumentId: string): Promise<ServiceReport[]> => {
    const res = await databases.listDocuments(DB, COL, [
        Query.equal("idInstrument", instrumentId),
        Query.notEqual("status", "draft"),
        Query.orderDesc("$createdAt"),
        Query.limit(100),
    ])
    return res.documents as unknown as ServiceReport[]
}

export const getReportsByInstrumentPaginated = async (
    instrumentId: string,
    limit: number
): Promise<{ documents: ServiceReport[]; total: number }> => {
    const res = await databases.listDocuments(DB, COL, [
        Query.equal("idInstrument", instrumentId),
        Query.notEqual("status", "draft"),
        Query.orderDesc("$createdAt"),
        Query.limit(limit),
    ])
    return {
        documents: res.documents as unknown as ServiceReport[],
        total: res.total,
    }
}

export const getDraftsByInstrument = async (instrumentId: string): Promise<ServiceReport[]> => {
    const res = await databases.listDocuments(DB, COL, [
        Query.equal("idInstrument", instrumentId),
        Query.equal("status", "draft"),
        Query.orderDesc("$updatedAt"),
    ])
    return res.documents as unknown as ServiceReport[]
}

export const getRevisionCount = async (originalIdReport: string): Promise<number> => {
    const res = await databases.listDocuments(DB, COL, [
        Query.equal("parentReportId", originalIdReport),
        Query.limit(1),
    ])
    return res.total
}